import type { IdReference, WebSiteLeaf } from "schema-dts";
import { organizationId, websiteId } from "../helpers/ids";
import type { SchemaBuilder } from "../types";

/**
 * `WebSite` — o site publicado como entidade. Sai em toda página, com o mesmo
 * `@id` em todas elas, e aponta para a `Organization` do canal como `publisher`.
 *
 * `name` é o nome do canal, não o da organização: o `WebSite` identifica o site,
 * e o override de `organizationName` existe para nomear quem publica.
 */
export const buildWebSite: SchemaBuilder = ({
  baseUrl,
  channelPublicId,
  siteName,
}) => {
  const publisher: IdReference = { "@id": organizationId(channelPublicId) };

  const node: WebSiteLeaf = {
    "@type": "WebSite",
    "@id": websiteId(channelPublicId),
    url: `${baseUrl}/`,
    name: siteName ?? undefined,
    publisher,
  };

  return [node];
};
